<template>
    <div class="w-full">
        <slot name="header-content"></slot>
        <slot name="body-content"></slot>
        <div>
            <label for="phone">{{ step.label }}</label>
            <Multiselect
            class=".multiselect__option--highlight"
            v-model="inputData" 
            :options="step.valueList" 
            :searchable="false" 
            :close-on-select="false"
            :preserve-serarch="true"
            :multiple="true"
            placeholder="Select all that apply"
            selectLabel=""
            deselectLabel="Click to remove"
            ></Multiselect>
        </div>
        <ButtonSection
            v-if="showButton"
            :inputValid="inputData.length"
            :order="order"
            :buttonText="step.buttonText"
            :backButtonText="step.backButtonText"
            :exitButtonText="step.exitButtonText"
            v-on:progress="$emit('progress')"
            @hide-modal="$emit('hide-modal')"
            @back="$emit('back')"
        />
        <slot name="login"></slot>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import ButtonSection from './ButtonSection.vue'
export default {
    props: ['step', 'showButton', 'value'],
    components: {Multiselect, ButtonSection},

    data() {
        return {
            inputData: []
        }
    },
    watch: {
        inputData(){
            this.$emit('input', {'value': this.inputData, 'valid': true})
            this.$emit('anonymousMonitoringSegment', this.inputData)
        }
    }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tag-icon:hover:after {
  color: #0384FB;
}
.multiselect__tag-icon:hover {
    background-color: #F0F6FE;
}
.multiselect__tag {
    background-color: #F0F6FE;
    text-transform: uppercase;
    color: #0384FB;
    border-radius: 0px;
} 
.multiselect__option--highlight {
    background-color: #0384FB
}
.multiselect__option--highlight:after{
    background-color: #0384FB
}

.multiselect__option--selected.multiselect__option--highlight:after {
    background-color: #0384FB;
    content: attr(data-deselect);
    color: #fff;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: #0384FB;
  color: #fff;
}

.multiselect__tags{
    border: 1px solid #0384FB;
}
.multiselect__placeholder {
  color: #00263E;
  font-size: 16px;

}

.multiselect__select:before{
    border-color: #191D1F transparent transparent
}
</style>
<style lang="scss" scoped>

</style>